module.exports = __webpack_public_path__ + "static/media/theme-custome.f4e728d9.jpg";